module.exports = __webpack_public_path__ + "static/media/slider-2.bdc46acc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-2.jpg
// module id = 1188
// module chunks = 33